// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u1iP","left":"styles_left__2x0rH","desktopActions":"styles_desktopActions__1huPq","title":"styles_title__2WSlQ"};